import { makeStyles } from "@mui/styles";

const zoomControlStyle = makeStyles({
    zoomControls: {
        position: "absolute",
        bottom: "1.5rem",
        right: "1.5rem",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
        borderRadius: "23px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "4px 5px",
        zIndex: 1000,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    },
    zoomButton: {
        color: "#333",
        backgroundColor: "transparent",
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        margin: "0 5px",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
        },
    },
});

export default zoomControlStyle;
